import { RootState } from '../models';

export const selectDuration = (state: RootState) => state.video.duration;